/**
 * About us на главной (group-46).
 */

import { ABOUT_COPY } from "../config/about";
import "./HomeAbout.css";

function HomeAbout() {
    return (
                    <div className="group-46">
                        <div className="group-46__container">
                            <h2 className="group-46__label">{ABOUT_COPY.label}</h2>
                            <h1 className="group-46__title">
                                {ABOUT_COPY.titleLines[0]}<br />{ABOUT_COPY.titleLines[1]}
                            </h1>
                            <p className="group-46__description">
                                {ABOUT_COPY.description}
                            </p>
                            <button className="group-46__button">{ABOUT_COPY.button}</button>
                        </div>
                    </div>
    );
}

export default HomeAbout;
// pages/HomeAbout.js
